// T0 — Tokens centralisés du design system (source unique de vérité visuelle).
// Couleurs/icônes par MODULE (axes ScanBank), par ACTEUR SYSTÈME, par STATUT et par CRITICITÉ.
// Réutilisés par les composants doc/ et par toutes les pages -> homogénéisation.
// Les noms d'icônes correspondent aux exports de `lucide-react` (résolus via components/ui/Icon.js).

export const MODULES = {
  PARAMETRAGE: { key: 'PARAMETRAGE', label: 'Paramétrage',            color: '#6366F1', icon: 'Settings2' },
  AUDIT:       { key: 'AUDIT',       label: "Suivi d'audit",          color: '#3B82F6', icon: 'Activity' },
  REPORTS:     { key: 'REPORTS',     label: 'Rapports & Supervision', color: '#10B981', icon: 'BarChart3' },
  TRANSVERSE:  { key: 'TRANSVERSE',  label: 'Transverse',             color: '#64748B', icon: 'Layers' },
};

// 1 entrée par acteur système de la chaîne ScanBank (collecte CBS -> dépôt -> ingestion -> restitution).
export const AGENT_TYPES = {
  GENERO_COLLECTEUR: { label: 'Collecteur GENERO',   icon: 'FileCode2',   color: '#8B5CF6', protocols: ['SQL', 'XML'] },
  CBS_AMPLITUDE:     { label: 'CBS Amplitude',       icon: 'Landmark',    color: '#F97316', protocols: ['TNS', 'SQL'] },
  SFTP:              { label: 'Dépôt SFTP',          icon: 'FolderInput', color: '#06B6D4', protocols: ['SFTP', 'SSH'] },
  BACKEND_SCANBANK:  { label: 'Backend ScanBank',    icon: 'Server',      color: '#3B82F6', protocols: ['HTTP', 'HTTPS', 'REST'] },
  FRONTEND_SCANBANK: { label: 'Frontend ScanBank',   icon: 'AppWindow',   color: '#EC4899', protocols: ['HTTP', 'HTTPS'] },
  POSTGRESQL:        { label: 'PostgreSQL',          icon: 'Database',    color: '#2563EB', protocols: ['SQL', 'JDBC'] },
  WORKFLOW_ENGINE:   { label: 'Moteur de workflow',  icon: 'GitBranch',   color: '#10B981', protocols: ['INTERNE'] },
  SCHEDULER:         { label: 'Ordonnanceur (jobs)', icon: 'Clock',       color: '#EAB308', protocols: ['CRON'] },
  NOTIFICATION:      { label: 'Notifications',       icon: 'Bell',        color: '#059669', protocols: ['SMTP', 'HTTP'] },
};

export const STATUS = {
  published:  { label: 'Publié',    color: '#10B981' },
  draft:      { label: 'Brouillon', color: '#F59E0B' },
  deprecated: { label: 'Déprécié',  color: '#EF4444' },
  active:     { label: 'Actif',     color: '#10B981' },
  warning:    { label: 'Attention', color: '#F59E0B' },
  error:      { label: 'Erreur',    color: '#EF4444' },
};

export const CRITICALITY = {
  P0: { label: 'P0 — Bloquant',  color: '#EF4444' },
  P1: { label: 'P1 — Important', color: '#F59E0B' },
  P2: { label: 'P2 — Confort',   color: '#10B981' },
};

export const moduleOf = (key) => MODULES[key] || MODULES.TRANSVERSE;
export const agentOf = (key) => AGENT_TYPES[key] || null;
